import ApiCore from "./api_core"
import { NewPerson } from "./types"

export default new class {
    create(person: NewPerson) { return ApiCore.postJson('/people', person) }

    update(id: number, person: NewPerson, programID: number) { 
        return ApiCore.putJson(`people/${id}`, { ...person, program_id: programID})
    }

    findFamilyName(name: string) {
        return ApiCore.getJson('/search/family_name', { search_string: name})
    }

    findGivenName(name: string) {
        return ApiCore.getJson('/search/given_name', { search_string: name})
    }

    getNameByPersonID(id: number) { return ApiCore.getJson(`/people/${id}/names`) }
}
